import { render, staticRenderFns } from "./NavbarStick.vue?vue&type=template&id=13119048&scoped=true&"
import script from "./NavbarStick.vue?vue&type=script&lang=js&"
export * from "./NavbarStick.vue?vue&type=script&lang=js&"
import style0 from "./NavbarStick.vue?vue&type=style&index=0&id=13119048&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13119048",
  null
  
)

export default component.exports